import { forwardRef, useState } from "react";
import { Icon } from "../../icons";
import { TextInput, type TextInputProps } from "../TextInput/TextInput";

export type PasswordInputProps = Omit<TextInputProps, "type" | "trailing">;

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(props, ref) {
  const [visible, setVisible] = useState(false);
  return (
    <TextInput
      ref={ref}
      type={visible ? "text" : "password"}
      icon={props.icon ?? "lock"}
      {...props}
      trailing={<RevealButton visible={visible} onToggle={() => setVisible((v) => !v)} />}
    />
  );
});

function RevealButton({ visible, onToggle }: { visible: boolean; onToggle: () => void }): React.JSX.Element {
  return (
    <button
      type="button"
      className="nb-icon-btn nb-icon-btn-sm"
      aria-label={visible ? "Hide password" : "Show password"}
      aria-pressed={visible}
      onClick={onToggle}
    >
      <Icon name={visible ? "eyeOff" : "eye"} />
    </button>
  );
}
